import { render, staticRenderFns } from "./InventoryUpload.vue?vue&type=template&id=79daa8c8&"
import script from "./InventoryUpload.vue?vue&type=script&lang=js&"
export * from "./InventoryUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports